import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import React, { useEffect } from "react";
import { actions as ConnectionActions } from "../../../Ducks/Connection.duck";
import { actions as DownloadsActions } from "../../../Ducks/Downloads.duck";
import Grid from "@mui/material/Grid";
import DownloadsTable from "../../../Packages/InsuranceBrydge/Components/DownloadsTable";
import { useBreadcrumb } from "app/components/Breadcrumbs";
const DownloadsTab = () => {
  const dispatch = useDispatch();
  const { connectionId } = useParams();
  const { items, totalCount } = useSelector((state) => state.DownloadsReducer);
  const { loading } = useSelector((state) => state.ConnectionReducer);
  useEffect(() => {
    dispatch(ConnectionActions.requestData(connectionId));
    dispatch(DownloadsActions.setConnectionId(connectionId));
    dispatch(DownloadsActions.requestData(connectionId));
  }, [connectionId, dispatch]);
  const downloadFile = (filePath) => {
    dispatch(DownloadsActions.downloadFile(filePath));
  };
  const deleteFile = (filePath) => {
    dispatch(DownloadsActions.deleteFile(filePath));
  };
  useBreadcrumb("button.downloads");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 5 }, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(
    DownloadsTable,
    {
      files: items,
      totalCount,
      loading,
      downloadFile,
      deleteFile
    }
  ))));
};
export default DownloadsTab;
